angular.module('elfium').directive('userLogin', ['elfiumUrlService', function (elfiumUrlService) {
    return {
        restrict: 'E',
        scope: {},
        controller: 'userController',
        templateUrl: elfiumUrlService.getTemplateUrl('user', 'userLogin')
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/user/userLogin.ts